import { render, staticRenderFns } from "./calendarMonthSelector.vue?vue&type=template&id=8ddcafae&"
import script from "./calendarMonthSelector.vue?vue&type=script&lang=js&"
export * from "./calendarMonthSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports